/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EdpCommitmentDetails {
    getFixupPrototypeFunction() { return EdpCommitmentDetails.fixupPrototype; }

    static newInstance(model: Partial<EdpCommitmentDetails>): EdpCommitmentDetails {
        let obj = Object.assign(new EdpCommitmentDetails(), model);
        EdpCommitmentDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EdpCommitmentDetails>): EdpCommitmentDetails {
        if (!model) return null;
        return EdpCommitmentDetails.newInstance(<EdpCommitmentDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EdpCommitmentDetails) {
        if (!obj) return;

        models.EdpCommitmentDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EdpCommitmentDetails): boolean {
        Object.setPrototypeOf(obj, EdpCommitmentDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.committed_amount === undefined) {
            this.committed_amount = 0;
        }
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Enterprise Discount Program start date.
     */
    start_date: Date;

    /**
     * Enterprise Discount Program end date.
     */
    end_date: Date;

    /**
     * Amount for the specified period.
     */
    committed_amount: number;

}
